import { ReactNode, useContext, useMemo } from 'react';

import { GlobalStyles, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import { SnackbarProvider } from 'notistack';

import InternationalizationProvider from '@/app/ui/InternationalizationProvider';
import getTheme from '@/config/theme';
import QueryProvider from '@/react-query/QueryProvider';
import { AccessDeniedProvider } from '@/shared/lib/AccessDeniedContext/AccessDeniedContext';
import { UserTypeContext } from '@/shared/lib/UserTypeContext/UserTypeContext';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  const userType = useContext(UserTypeContext);
  const theme = useMemo(() => getTheme(userType), [userType]);

  return (
    <InternationalizationProvider>
      <SnackbarProvider
        maxSnack={7}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={4000}
        preventDuplicate
        dense
        classes={{ containerAnchorOriginBottomRight: 'snackbar-container-bottom-right' }}
      >
        <AccessDeniedProvider>
          <QueryProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <GlobalStyles
                styles={{
                  '.snackbar-container-bottom-right': {
                    bottom: 'calc(var(--upload-progress-offset, 0px) + 1rem) !important',
                    right: '1rem !important',
                    transition: 'bottom 0.3s ease',
                    gap: '0.25rem',
                  },
                }}
              />
              {children}
            </ThemeProvider>
          </QueryProvider>
        </AccessDeniedProvider>
      </SnackbarProvider>
    </InternationalizationProvider>
  );
}
